import { format } from 'date-fns';
import styled from 'styled-components';

import DateRangeBadge from 'components/shared/DateRangeBadge';
import DesktopOnly from 'components/shared/responsiveness/DesktopOnly';
import MobileOnly from 'components/shared/responsiveness/MobileOnly';
import { END_DATE, START_DATE } from 'constants/filterKeysConstants';
import { useInboundReferralsInsightsStore } from 'stores/inboundReferralsInsightsStore';
import { BodySmallBold } from 'styles/typography';

import { getInboundExportFilename, getInboundExportParams, INBOUND_VIEW_BY_DIMENSION_MAP } from '../constants';
import InboundReferralApiExport from '../InboundReferralApiExport';

export default function InboundReferralDetailsHeader() {
  const startDate = useInboundReferralsInsightsStore((state) => state.filters[START_DATE]) as Date;
  const endDate = useInboundReferralsInsightsStore((state) => state.filters[END_DATE]) as Date;
  const viewBy = useInboundReferralsInsightsStore((state) => state.viewBy);

  const dimension = INBOUND_VIEW_BY_DIMENSION_MAP[viewBy];

  return (
    <Header>
      <TitleGroup>
        <TitleColumn>
          <Title>Inbound Referral Details</Title>
          <MobileOnly>
            <Subtitle>
              {format(startDate, 'MM/dd/yyyy')} - {format(endDate, 'MM/dd/yyyy')}
            </Subtitle>
          </MobileOnly>
        </TitleColumn>
        <DesktopOnly>
          <DateRangeBadge startDate={startDate} endDate={endDate} />
        </DesktopOnly>
      </TitleGroup>
      <RightGroup>
        <InboundReferralApiExport
          filename={getInboundExportFilename(viewBy)}
          params={getInboundExportParams(dimension)}
        />
      </RightGroup>
    </Header>
  );
}

const Header = styled.div`
  padding: 24px;
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const TitleGroup = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
`;

const TitleColumn = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

const Title = styled(BodySmallBold)`
  color: ${({ theme }) => theme.colors.black100};
`;

const Subtitle = styled.span`
  color: ${({ theme }) => theme.colors.black50};
  font-size: 10px;
  font-weight: normal;
`;

const RightGroup = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
`;
